msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: nb_NO\n"
"Project-Id-Version: 5b236266dda1bdf711f2dec226a4db34\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Norwegian Bokmal\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 5b236266dda1bdf711f2dec226a4db34\n"
"X-Crowdin-Project-ID: 574\n"
"X-Crowdin-Language: nb\n"
"X-Crowdin-File-ID: 25408\n"

#. Suffix part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the ' | FINN.no' part, including the space at the beginning)
#. js-lingui-explicit-id
#: src/server/server.ts:225
msgid "page.title.suffix"
msgstr " | FINN.no"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:230
#: src/server/pages/default-landing.tsx:117
msgid "content.card2.title"
msgstr "... Legg det ut enkelt med AI"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:27
#: src/server/pages/images.ts:68
#: src/server/pages/images.ts:110
msgid "content.image.finn.intro2.alt"
msgstr "En hånd holder en smarttelefon som viser et bilde av en kremfarget strikket pologenser mot rosa bakgrunn, med selve genseren synlig under telefonen."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:318
#: src/server/pages/default-landing.tsx:234
msgid "content.steps.step3.description"
msgstr "AI foreslår tittel og tekst. Du legger bare til pris og adresse før du publiserer."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:291
#: src/server/pages/default-landing.tsx:207
msgid "content.steps.step1.description"
msgstr "Vinkel, belysning, antall - AI gir deg gode råd i annonseinnleggingen!"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:35
msgid "content.image.finn.intro3.alt"
msgstr "Nærbilde av en smarttelefon som viser et varsel fra FINN-appen om at pengene er på vei og kan ta 2–5 virkedager før de vises på kontoen, mot en uskarp bakgrunn i varme toner."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:76
#: src/server/pages/images.ts:118
msgid "content.image.tori.intro3.alt"
msgstr "Nærbilde av en smarttelefon som viser et varsel fra Tori-appen om at pengene er på vei og vil vises på kontoen om omtrent 2–5 virkedager, mot en varm, uskarp bakgrunn med lys."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:43
msgid "content.image.finn.aiHelper.alt"
msgstr "Nærbilde av en smarttelefon som viser FINNs AI-assistent som automatisk fyller inn produktdetaljer, inkludert merke, type, størrelse og farge, med tekst som forklarer at brukeren kan justere eventuell feil informasjon."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:84
#: src/server/pages/images.ts:126
msgid "content.image.tori.aiHelper.alt"
msgstr "Nærbilde av en smarttelefon som viser AI-assistenten på Tori, som automatisk fyller inn produktdetaljer som merke, type og størrelse, med tekst som forklarer at brukeren kan justere eventuell feil informasjon."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:19
#: src/server/pages/images.ts:60
#: src/server/pages/images.ts:102
msgid "content.image.finn.intro1.alt"
msgstr "Kremfarget strikket pologenser med strukturmønster, ribbekrage og to knapper, brettet pent på en rosa bakgrunn."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:313
#: src/server/pages/default-landing.tsx:229
msgid "content.steps.step3.title"
msgstr "Detaljene fylles inn automatisk"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:56
msgid "content.title"
msgstr "Har du penger i klesskapet?"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:208
#: src/server/pages/default-landing.tsx:95
msgid "content.card1.title"
msgstr "Finn frem ting du ikke bruker..."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:51
msgid "content.image.finn.testimonial.alt"
msgstr "Portrett av Vigdis"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:279
#: src/server/pages/default-landing.tsx:197
msgid "content.steps.title"
msgstr "Slik fungerer AI-hjelperen"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:299
#: src/server/pages/default-landing.tsx:215
msgid "content.steps.step2.title"
msgstr "La AI finne riktig kategori"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:213
#: src/server/pages/default-landing.tsx:100
msgid "content.card1.description"
msgstr "Kanskje en fin jakke eller gammel iPad? Tjen penger på at andre får glede av det!"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:252
#: src/server/pages/default-landing.tsx:137
msgid "content.card3.title"
msgstr "Penger rett i lomma!"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:59
msgid "content.description"
msgstr "Akkurat nå er det lurt å selge det du ikke bruker! Lag annonsen på under 2 minutter med FINN sitt nye AI-verktøy."

#. js-lingui-explicit-id
#: src/islands/create-item-button/create-item-button.tsx:43
msgid "button.createItem"
msgstr "Legg ut annonse"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:326
#: src/server/pages/default-landing.tsx:242
msgid "content.steps.step4.title"
msgstr "Publiser"

#. Main part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the 'Selg med AI' part)
#. js-lingui-explicit-id
#: src/server/server.ts:218
msgid "page.title.main"
msgstr "Selg med AI"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:235
#: src/server/pages/default-landing.tsx:120
msgid "content.card2.description"
msgstr "Ta et bilde av produktet du vil selge, så hjelper AI deg med tittel, tekst og kategori."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:286
#: src/server/pages/default-landing.tsx:202
msgid "content.steps.step1.title"
msgstr "Ta best mulige bilder"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:304
#: src/server/pages/default-landing.tsx:220
msgid "content.steps.step2.description"
msgstr "Bildene analyseres fortløpende og plasserer det du selger automatisk i riktig kategori på FINN."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:257
#: src/server/pages/default-landing.tsx:142
msgid "content.card3.description"
msgstr "Pengene tikker trygt rett inn på konto så fort kjøperen har betalt trygt via FINN."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:329
#: src/server/pages/default-landing.tsx:245
msgid "content.steps.step4.description"
msgstr "Denne må du gjøre selv, gitt!"

